<template>
    <div>
      <div class="d-md-flex align-center justify-space-between">
        <div style="display:inline-flex">
          <h1 class="mb-0 mr-3 pt-1">Affiliate Profiles</h1>
          <v-btn color="primary" @click="addAffiliate"><v-icon class="mb-0 mr-3">mdi-plus</v-icon> New Affiliate</v-btn>
        </div>
        <div v-if="!showCheckBoxes">
          <v-btn @click="exportAffiliatesList" color="primary" class="btn-inner">
            <v-icon class="mr-2">mdi-download</v-icon>
            Export
          </v-btn>
          <v-btn @click="massAssign" color="primary" class="btn-inner"
                 v-if="user[0].can('can_mass_assign_approve')">
            <v-icon class="mr-2">mdi-plus-box-multiple-outline</v-icon>
            Mass Assign
          </v-btn>
          <v-btn @click="massActivation" color="primary" class="btn-inner">
            <v-icon class="mr-2">mdi-plus-box-multiple-outline</v-icon>
            Mass Activation
          </v-btn>
          <v-btn @click="massSuspend" color="warning" class="mr-2">
            <v-icon class="mr-2">mdi-close-box-multiple-outline</v-icon>
            Mass Suspension
          </v-btn>
          <v-btn @click="massReject" color="error" class="btn-inner">
            <v-icon class="mr-2">mdi-close-box-multiple-outline</v-icon>
            Mass Rejection
          </v-btn>
        </div>
        <div v-else>
          <div
            style="display: inline-block; margin-right: 10px; width: 250px;">
            <v-select
              :hide-details="true"
              class="ma-0 pa-0"
              :items="managersList"
              item-value="id"
              item-text="name"
              v-if="currentAction === 'assignment'"
              label="Assign to"
              v-model="assignManager"
            />
          </div>
          <v-btn @click="confirm" color="primary" class="btn-inner" :disabled="!this.ids.length">Confirm {{currentAction}}</v-btn>
          <v-btn @click="cancel" color="primary">Cancel</v-btn>
        </div>
      </div>
        <COProfiles
                :showSelect="showCheckBoxes"
                @selected="enterSelect"
                :preselected-filters="filter"
                :key="componentKey"
                :exportAffiliatesList="exportAffiliatesList"
                ref="coProfilesRef"
        >
        </COProfiles>
    </div>

</template>

<script>
  import store from '@/store';
  import COProfiles from "@/components/pages/affiliates/profiles/COProfiles";
  import managers from '@/api/managers';
  import {mapState} from "vuex";

  export default {
    components: {
      COProfiles,
    },
    computed: {
      ...mapState('user', ['user']),
    },
    data() {
        return {
            showCheckBoxes: false,
            currentAction: '',
            filter: false,
            componentKey: 1,
            ids: [],
            managersList: [],
            assignManager: null,
        }
    },
    methods: {
        enterSelect(data){
            this.ids = data.map(item => item.id);
            console.log(this.ids);
        },
        applyFilter(isReset = false, filter = 'pending') {
            if (isReset) {
                this.filter = false;
            } else {
                this.filter = {
                    status: [filter],
                };
                if (this.currentAction === 'activate') {
                    this.filter.onlyAssigned = ['true'];
                }
            }
            this.componentKey += 1;
        },
        toggleShowCheckBoxes() {
            this.showCheckBoxes = !this.showCheckBoxes;
        },
        async massAssign() {
            this.currentAction = 'assignment';
            this.componentKey += 1;
            this.toggleShowCheckBoxes();
            try {
              const response = await managers.getMassAssignManagerList();
              this.managersList = response.data.data.massAssignManagerList;
            } catch(err) {
              store.dispatch('alert/ALERT_SUCCESS', err.message, {root: true});
            }
        },
        massActivation() {
            this.currentAction = 'activate';
            this.applyFilter();
            this.toggleShowCheckBoxes();
        },
        massReject() {
            this.currentAction = 'reject';
            this.applyFilter();
            this.toggleShowCheckBoxes();
        },
        massSuspend() {
          this.currentAction = 'suspend';
          this.applyFilter(false, 'active');
          this.toggleShowCheckBoxes();
        },
        async confirm() {
            if (this.currentAction === 'assignment') {
              return this.confirmAssign();
            }
            if (!this.ids.length) {
              return this.reset();
            }
            const status = this.currentAction === 'activate' ? 'active' : (this.currentAction === 'reject' ? 'rejected' : 'suspended');
            try {
                await store.dispatch('affiliates/massUpdate', {status, ids: this.ids});
                store.dispatch('alert/ALERT_SUCCESS', `All assigned accounts are now ${status}`, {root: true});
            } catch (err) {
                console.log(err);
                store.dispatch('alert/ALERT_ERROR', err.message, {root: true});
            }

            setTimeout(() => {
                store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
            }, 3000);

            this.reset();
        },
        async confirmAssign() {
          if (!this.assignManager) {
            store.dispatch('alert/ALERT_ERROR', 'Please select someone to assign the accounts to', {root: true});
          }
          if (!this.ids.length) {
            store.dispatch('alert/ALERT_ERROR', 'Please select one or more accounts to assign', {root: true});
          }

          await store.dispatch('affiliates/massAssign', {
            managerId: this.assignManager,
            ids: this.ids
          });
          let type = 'alert/ALERT_SUCCESS';
          if (store.state.affiliates.lastMassAssign.status === 'error') {
            type = 'alert/ALERT_ERROR'
          }
          store.dispatch(type, store.state.affiliates.lastMassAssign.message, {root: true});
          this.reset();
        },
        cancel() {
            this.reset();
        },
        reset() {
            this.toggleShowCheckBoxes();
            this.applyFilter(true);
            this.currentAction = '';
            this.ids = [];
        },
        exportAffiliatesList() {
          this.$refs.coProfilesRef.exportAffiliatesList();
        },
        addAffiliate() {
          this.$refs.coProfilesRef.addAffiliate();
        }


    }
  }
</script>

<style scoped lang="sass">
.search_btn_wrap
  .search_wrapper
    width: 250px
    padding-bottom: 15px
.btn-inner
  margin-right: 10px
</style>
